import React from 'react';

const P = {
  fontSize: '1.0625rem',
  lineHeight: 1.85,
  color: 'var(--gray)',
  marginBottom: '1.5rem',
  fontWeight: 300,
  maxWidth: '68ch'
};

// Secção 3 · Regime jurídico (fundo branco)
export const LegalFrameworkSection = () => (
  <section className="valuare-section" data-testid="herancas-legal-section">
    <div className="valuare-section-content">
      <div style={{ maxWidth: '820px', margin: '0 auto', textAlign: 'left' }}>
        <div className="valuare-section-label">Regime Jurídico</div>
        <h2 className="valuare-section-title">
          Lei n.º 49/2026,<br />
          <em>de 17 de agosto</em>
        </h2>
        <p style={P}>
          Foi publicada a 17 de agosto de 2026 a Lei n.º 49/2026, aprovada em votação final
          global na Assembleia da República a 17 de julho e promulgada a 7 de agosto. O diploma
          constitui uma autorização legislativa que habilita o Governo a criar o Regime Legal do
          Processo Especial de Venda de Coisa Imóvel integrada em Herança Indivisa e o Regime
          Legal da Arbitragem Sucessória determinada pelo autor da sucessão, bem como a introduzir
          alterações ao Código Civil, ao Código de Processo Civil e ao Regime da Procriação
          Medicamente Assistida.
        </p>
        <p style={P}>
          O novo processo especial, de natureza urgente, permitirá que qualquer herdeiro, o cônjuge
          meeiro sobrevivo ou o testamenteiro com poderes de partilha requeira judicialmente a venda
          de imóvel integrado em herança indivisa, sem necessidade do consentimento dos restantes.
          Existindo processo de inventário pendente, o pedido poderá ser apresentado de imediato.
          Nos demais casos, exigir-se-á o decurso de dois anos sobre a abertura da sucessão. Ficam
          ressalvadas as situações em que tenha sido celebrada convenção de indivisão, em que o
          direito à partilha não possa ser exercido ou em que a herança se encontre em situação de
          insolvência, prevendo-se ainda proteção da casa de morada de família. Havendo herdeiros
          incapazes ou ausentes, a venda dependerá do consentimento do Ministério Público e de
          autorização judicial.
        </p>
        <p style={P}>
          O diploma prevê igualmente que a administração da herança e as funções de cabeça-de-casal
          possam ser confiadas a outra pessoa por deliberação de maioria simples dos herdeiros, com
          ressalva dos casos em que o cabeça-de-casal seja o cônjuge sobrevivo e sem prejuízo das
          regras próprias aplicáveis quando exista testamenteiro com poderes de partilha.
        </p>
        <div
          style={{
            background: 'var(--cream)',
            borderLeft: '3px solid var(--gold)',
            borderRadius: '0 6px 6px 0',
            padding: '26px 30px',
            marginTop: '2.5rem',
            maxWidth: '68ch'
          }}
          data-testid="herancas-legal-callout"
        >
          <p style={{ fontSize: '1rem', lineHeight: 1.8, color: 'var(--navy)', margin: 0, fontWeight: 400 }}>
            O regime ainda não se encontra em vigor. A Lei n.º 49/2026 é uma autorização legislativa
            válida por 180 dias, prazo de que o Governo dispõe para publicar o decreto-lei que cria
            efetivamente o processo especial. Até lá, o novo processo não pode ser instaurado e o
            regime sucessório mantém-se inalterado. Os aspetos processuais descritos em seguida
            resultam da autorização legislativa e do anteprojeto que a acompanha, podendo o texto
            final apresentar diferenças. Esta página é atualizada logo que o decreto-lei seja
            publicado.
          </p>
        </div>
      </div>
    </div>
  </section>
);
